import {ISQLiteService } from '../services/sqliteService'; 
import {IStorageService,} from '../services/storageService'; 
import { AiChatPersistenceService } from './aiChatPersistenceService';
import { globalMessageQueue } from './persistentMessageQueue';
import { CapacitorSQLite, SQLiteConnection } from '@capacitor-community/sqlite';

const sqlite = new SQLiteConnection(CapacitorSQLite);

export interface IInitializeAppService {
    initializeApp(): Promise<boolean>
};

class InitializeAppService implements IInitializeAppService  {
    appInit = false;
    sqliteServ!: ISQLiteService;
    storageServ!: IStorageService;
    aiChatPersistenceServ!: AiChatPersistenceService;
   
    platform!: string;
  static platform: string;

    constructor(sqliteService: ISQLiteService, storageService: IStorageService, aiChatPersistenceService: AiChatPersistenceService) {
        this.sqliteServ = sqliteService;
        this.storageServ = storageService;
        this.aiChatPersistenceServ = aiChatPersistenceService;
        this.platform = this.sqliteServ.getPlatform();
    }
    async initializeApp(): Promise<boolean> {
      console.log('开始应用初始化1');
        if (!this.appInit) {
          try {
            console.log('开始应用初始化2');

          //   if (this.platform === 'web') {
          //     try {
          //       await this.sqliteServ.saveToStore(this.database);
          //       console.log('数据库已保存到 Web 存储');
      
          //            // Create the 'jeep-sqlite' Stencil component
          //   const jeepSqlite = document.createElement('jeep-sqlite');
          //   document.body.appendChild(jeepSqlite);
          //   await customElements.whenDefined('jeep-sqlite');
          //   // Initialize the Web store
          // //  const databaseName = await this.storageServ.getDatabaseName()
          //           await this.sqliteServ.initWebStore();
          //         console.log('Web 存储初始化完成');
          //         await this.sqliteServ.openDatabase(this.database,5, false);
          //         console.log('Web 存储数据库打开完成');
          //     } catch (err) {
          //       console.warn('Web 存储保存失败（非致命错误）:', err);
          //     }
          //   }            await this.sqliteServ.saveToStore(databaseName);

            if (this.platform === 'web') {
            
                 // Create the 'jeep-sqlite' Stencil component
      const jeepSqlite = document.createElement('jeep-sqlite');
      document.body.appendChild(jeepSqlite);
      await customElements.whenDefined('jeep-sqlite');
      // Initialize the Web store
     const databaseName = await this.storageServ.getDatabaseName()
              await this.sqliteServ.initWebStore();
   
              await this.sqliteServ.addUpgradeStatement({
                database: databaseName,
                upgrade: this.storageServ.versionUpgrades,
              });
              console.log('核心升级语句已添加');

            await this.sqliteServ.openDatabase(databaseName, 5, false);
            console.log('Web 存储初始化完成');
          //  await this.sqliteServ.openDatabase(databaseName,5, false);
   // console.log('Database opened successfully');


            }



            await this.storageServ.initializeDatabase();
           // console.log('数据库初始化完成');
            
            // 初始化AI聊天持久化服务
            await this.aiChatPersistenceServ.initialize();
           // console.log('AI聊天持久化服务初始化完成');
            
            // 初始化全局消息队列服务
            await globalMessageQueue.initialize();
           // console.log('全局消息队列服务初始化完成');
            
            if (this.platform === 'web') {
              await this.sqliteServ.saveToStore(this.storageServ.getDatabaseName());
             // console.log('数据库保存到 Web 存储完成');
            }
            this.appInit = true;
           // console.log('应用初始化成功');
          } catch (error: any) {
            const msg = error.message ? error.message : error;
           // console.error(`initializeAppError.initializeApp: ${msg}`, error);
            throw new Error(`initializeAppError.initializeApp: ${msg}`);
          }
        }
        return this.appInit;
      }
    }
   
export default InitializeAppService;
